module.exports = __webpack_public_path__ + "media/dashboard/assets/images/credit-card/master-card-a3c232f5a6c54edf8d3c67734ad82671.svg";